// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `in-button {
  display: block;
}

::ng-deep.c-onecolumn-form_label__content {
  min-width: 25%;
}

::ng-deep.c-input_large {
  max-width: none;
}

::ng-deep in-input-text.type_varchars {
  width: 75%;
  display: inline-flex;
}

.form_body {
  display: flex;
  flex-direction: column;
}

.bottom-action-block {
  display: flex;
  gap: 22px;
}

.tooltip-wrapper {
  padding: 16.5px 13px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
